import { env } from "@bkry/bowline-utils";
import PropTypes from "prop-types";
import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import Carousel from "react-multi-carousel";
import ReactPlayer from "react-player";
import { Col, Container, Row } from "reactstrap";

const { REACT_APP_CDN_PATH } = env;

const MINIO_ENDPOINT = "https://metadata.bowline.app/0xsamsunggen3rator/assets"; // ! TODO

const Gen3ratorPartnerPrices = (props, context) => {
  const partners = [
    {
      title: "Illuvium GEN3RATOR",
      text: context.t("generators.about.illuvium.text"),
      video: `${MINIO_ENDPOINT}/illuvium/preview.mp4`,
      prices: [
        {
          title: "Incl. Samsung Ranger Suit Skin",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Illuvium_1.png",
          externalLink: "https://illuvium.io/",
        },
        {
          title: "Incl. Samsung Bach Drone Skin",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Illuvium_2.png",
          externalLink: "https://illuvium.io/",
        },
        {
          title: "Incl. Samsung Chopin Drone Skin",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Illuvium_3.png",
          externalLink: "https://illuvium.io/",
        },
        {
          title: "Incl. Samsung Hilde Drone Skin",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Illuvium_4.png",
          externalLink: "https://illuvium.io/",
        },
        {
          title: "Incl. Samsung Mozart Drone Skin",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Illuvium_5.png",
          externalLink: "https://illuvium.io/",
        },
      ],
      pricesCopy: context.t("generators.prices.illuvium.copy"),
    },
    {
      title: "Ledger GEN3RATOR",
      text: context.t("generators.about.ledger.text"),
      video: `${MINIO_ENDPOINT}/ledger/preview.mp4`,
      prices: [
        {
          title: "50x Ledger Nano X - Custom Limited Samsung x Ledger",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Ledger_Nano_X_Neu.png",
          externalLink: "https://www.ledger.com/de",
        },
      ],
      pricesCopy: context.t("generators.prices.ledger.copy"),
    },
    {
      title: "Wilder Worlds GEN3RATOR",
      text: context.t("generators.about.wilderworlds.text"),
      video: `${MINIO_ENDPOINT}/wilderworld/preview.mp4`,
      prices: [
        {
          title: "5x GENs",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Wilder_Gens.png",
          externalLink: "https://opensea.io/category/welcome-to-wilder-world",
        },
        {
          title: "7x Motos",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Wilder_Motos.png",
          externalLink: "https://opensea.io/category/welcome-to-wilder-world",
        },
        {
          title: "3x Wapes",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Wilder_Wapes.png",
          externalLink: "https://opensea.io/category/welcome-to-wilder-world",
        },
        {
          title: "1x Wolfs",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Wilder_Beasts.png",
          externalLink: "https://opensea.io/category/welcome-to-wilder-world",
        },
        {
          title: "4x Wheels",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Wilder_Wheels.png",
          externalLink: "https://opensea.io/category/welcome-to-wilder-world",
        },
      ],
      pricesCopy: context.t("generators.prices.wilderworlds.copy"),
    },
    {
      title: "World of Women GEN3RATOR",
      text: context.t("generators.about.wow.text"),
      video: `${MINIO_ENDPOINT}/worldofwomen/preview.mp4`,
      prices: [
        {
          title: "5x WoW",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_WoW.png",
          externalLink: "https://opensea.io/collection/world-of-women-nft",
        },
        {
          title: "20x WoWG",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_WoWG.png",
          externalLink: "https://opensea.io/collection/world-of-women-galaxy",
        },
        {
          title: "50x WoW Artfest",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_woW_artfest.png",
          // externalLink: ""
        },
      ],
      pricesCopy: context.t("generators.prices.wow.copy"),
    },
    {
      title: "Samsung GEN3RATOR",
      text: context.t("generators.about.samsung.text"),
      video: `${MINIO_ENDPOINT}/samsung/preview.mp4`,
      prices: [
        {
          title: "5x Samsung S23 Ultra",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_S23.png",
          // externalLink: ""
        },
        {
          title: "5x Samsung S24 Ultra",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_SEG_S24.png",
        },
        {
          title: "1x Samsung Sero TV TX1 Web3 Bundle",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_SEG3.png",
          // externalLink: ""
        },
        {
          title: `1x Samsung Frame TV TX1 Web3 Bundle 65"`,
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_SEG3.png",
          // externalLink: ""
        },
        {
          title: `1x Samsung Frame TV TX1 Web3 Bundle 55"`,
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_SEG3.png",
          // externalLink: ""
        },
        {
          title: "75x Belvedere The Kiss NFT",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/gen3rator/prices/500x500_Benefits_DETAILS_Belvedere.png",
          externalLink:
            "https://opensea.io/collection/belvedere-arteq-the-kiss-by-gustav-klimt",
        },
        {
          title: "5x Ledger Nano X MX1 Edition",
          image:
            (REACT_APP_CDN_PATH || "") +
            "/images/500x500_Benefits_DETAILS_Ledger_MX1_NANOX.png",
          // externalLink: ""
        },
      ],
      pricesCopy: context.t("generators.prices.samsung.copy"),
    },
  ];

  const renderPrice = (price, index) => {
    return (
      <div key={index} className="mx-5 position-relative ">
        <div className="ratio ratio-1x1">
          <img
            src={price.image}
            alt="Slide"
            className="rounded-4  object-fit-cover "
          />
        </div>
        <p className="h6 mt-3 px-3">{price.title}</p>
        {price.externalLink && (
          <a
            href={price.externalLink}
            target="_blank"
            rel="noopener noreferrer"
            className="stretched-link"
          ></a>
        )}
      </div>
    );
  };

  return (
    <div className="bigger-margin-top bigger-margin-bottom">
      <Container className="text-center mb-5">
        <h2>{context.t("generators.about.title")}</h2>
        <p>{context.t("generators.about.copy")}</p>

        <ScrollAnimation
          className="mt-5"
          animateIn="zoomIn"
          duration={2}
          delay={500}
        >
          <img
            src={
              (REACT_APP_CDN_PATH || "") + "/images/Samsung_Generator_Logic.png"
            }
            alt="Samsung Generator Logic"
            width="100%"
            height="auto"
          />
        </ScrollAnimation>
      </Container>
      <Container>
        {partners.map((partner, index) => (
          <div className="mb-5 bigger-margin-top" key={index}>
            <div className="text-center">
              <h3 className="mt-3 px-3">{partner.title}</h3>
              <p className="mt-1 px-3">{partner.text}</p>
            </div>
            <Row key={index} className="mb-5">
              <Col md={5} className="d-flex flex-column justify-content-center">
                <div className="">
                  {partner.video ? (
                    <ReactPlayer
                      url={partner.video}
                      controls={false}
                      playing={true}
                      playsinline
                      muted={true}
                      loop={true}
                      width="100%"
                      height="auto"
                    />
                  ) : (
                    <img
                      src={partner.image}
                      alt="Slide"
                      className="rounded-4  object-fit-cover "
                    />
                  )}
                </div>
              </Col>
              <Col md={{ size: 5, offset: 2 }}>
                <div className="mt-5">
                  <Carousel
                    responsive={{
                      mobile: {
                        breakpoint: { max: 99999, min: 0 },
                        items: 1,
                        slidesToSlide: 1, // optional, default to 1.
                      },
                    }}
                    autoPlay={true}
                    autoPlaySpeed={3000}
                    infinite={true}
                  >
                    {partner.prices.map((price, index) =>
                      renderPrice(price, index)
                    )}
                  </Carousel>
                </div>
              </Col>
            </Row>
            {partner.pricesCopy && (
              <Row>
                <Col md={{ size: 8, offset: 2 }}>
                  <p className="mt-3">{partner.pricesCopy}</p>
                </Col>
              </Row>
            )}
          </div>
        ))}
      </Container>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
Gen3ratorPartnerPrices.contextTypes = {
  t: PropTypes.func,
};

export default Gen3ratorPartnerPrices;
